import React from 'react';
import {bool, func, node, string} from 'prop-types';

import Button from '@material-ui/core/Button';

import classes from './CancelButton.module.css';

const CancelButton = ({
    cancel,
    children,
    className,
    disabled,
    hidden,
    onClick
}) => {
    if (hidden) {
        return null;
    }
    if (!onClick && cancel) {
        onClick = cancel;
    }

    return (
        <Button
            data-test-id="cancel"
            variant="contained"
            type="button"
            disabled={disabled}
            className={`${classes.cancel} ${className}`}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

CancelButton.defaultProps = {
    children:  'Cancel',
    className: '',
    hidden:    false
};

CancelButton.propTypes = {
    children:  node,
    className: string,
    hidden:    bool,
    onClick:   func
};

export default CancelButton;
